var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVerticalLinesDotted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00003 13.0038C4.99593 12.4468 5.44919 12 5.99816 12C6.54916 12 7.0003 12.4459 7.0003 13.0001C7.0003 13.5517 6.55176 14.0003 6.00016 14.0003C5.44978 14.0003 5.002 13.5537 5.00003 13.0038ZM5.42076 13.0001H5.00002C5.00002 13.0014 5.00002 13.0026 5.00003 13.0038",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00003 6.33703C4.99593 5.78003 5.44919 5.33325 5.99816 5.33325C6.54916 5.33325 7.0003 5.7792 7.0003 6.33339C7.0003 6.88499 6.55176 7.33353 6.00016 7.33353C5.44978 7.33353 5.002 6.88696 5.00003 6.33703ZM5.42076 6.33339H5.00002C5.00002 6.33461 5.00002 6.33582 5.00003 6.33703",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00003 3.00378C4.99593 2.44678 5.44919 2 5.99816 2C6.54916 2 7.0003 2.44595 7.0003 3.00014C7.0003 3.55174 6.55176 4.00028 6.00016 4.00028C5.44978 4.00028 5.002 3.55371 5.00003 3.00378ZM5.42076 3.00014H5.00002C5.00002 3.00135 5.00002 3.00257 5.00003 3.00378",
    className: "icon-fill"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 13.0038C8.99593 12.4468 9.44919 12 9.99816 12C10.5492 12 11.0003 12.4459 11.0003 13.0001C11.0003 13.5517 10.5518 14.0003 10.0002 14.0003C9.44978 14.0003 9.002 13.5537 9.00003 13.0038ZM9.42076 13.0001H9.00002C9.00002 13.0014 9.00002 13.0026 9.00003 13.0038",
    className: "icon-fill"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 6.33703C8.99593 5.78003 9.44919 5.33325 9.99816 5.33325C10.5492 5.33325 11.0003 5.7792 11.0003 6.33339C11.0003 6.88499 10.5518 7.33353 10.0002 7.33353C9.44978 7.33353 9.002 6.88696 9.00003 6.33703ZM9.42076 6.33339H9.00002C9.00002 6.33461 9.00002 6.33582 9.00003 6.33703",
    className: "icon-fill"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 3.00378C8.99593 2.44678 9.44919 2 9.99816 2C10.5492 2 11.0003 2.44595 11.0003 3.00014C11.0003 3.55174 10.5518 4.00028 10.0002 4.00028C9.44978 4.00028 9.002 3.55371 9.00003 3.00378ZM9.42076 3.00014H9.00002C9.00002 3.00135 9.00002 3.00257 9.00003 3.00378",
    className: "icon-fill"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00003 9.67053C4.99593 9.11353 5.44919 8.66675 5.99816 8.66675C6.54916 8.66675 7.0003 9.11269 7.0003 9.66689C7.0003 10.2185 6.55176 10.667 6.00016 10.667C5.44978 10.667 5.002 10.2205 5.00003 9.67053ZM5.42076 9.66689H5.00002C5.00002 9.6681 5.00002 9.66932 5.00003 9.67053",
    className: "icon-fill"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 9.67053C8.99593 9.11353 9.44919 8.66675 9.99816 8.66675C10.5492 8.66675 11.0003 9.11269 11.0003 9.66689C11.0003 10.2185 10.5518 10.667 10.0002 10.667C9.44978 10.667 9.002 10.2205 9.00003 9.67053ZM9.42076 9.66689H9.00002C9.00002 9.6681 9.00002 9.66932 9.00003 9.67053",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVerticalLinesDotted);
export default __webpack_public_path__ + "static/media/icon-vertical-lines-dotted.d268fa18fedfc313eb7d1b2b2d90fd62.svg";
export { ForwardRef as ReactComponent };